// Module
var code = "<template class=\"mooring-components-tab\">\n  <require from=\"./bridles-container\"></require>\n  <bridles-container mooring-id.bind=\"data.mooringId\" review-id.bind=\"data.activeReviewId\"></bridles-container>\n</template>\n";
// Exports
export default code;